import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import instance from "./utils/axiosInstance";
import Navbar from "./components/Navbar_test";
import Footer from "./components/Footer";
import Test from "./pages/Test";
import Login from "./pages/Login_test";
import Register from "./pages/Register_test";
import Profile from "./pages/Profile_test";
import Wallet from "./pages/Wallet_test";
import NFTManage from "./pages/NFTManage";
import NFTCreate from "./pages/NFTCreate_test";
import Home from "./pages/Home_test";
import NFTList from "./pages/NFTList";
import NFTDetail from "./pages/NFTDetail_test";
import MetaRegister from "./pages/MetaRegister";
import UserProfile from "./pages/UserProfile";
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./theme"
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import { Box } from "@mui/material"; // 추가
const App = () => {
    const [user, setUser] = useState(null);

    useEffect(() => {
      instance.get("/user/me", { withCredentials: true })
          .then(res => setUser(res.data.user))
          .catch(() => setUser(null)); // 인증 실패 시 로그아웃 처리
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        {/* 🔧 전체를 감싸는 flex column */}
        <Box display="flex" flexDirection="column" minHeight="100vh">
          <Navbar user={user} setUser={setUser} />

          {/* 🔧 메인 콘텐츠가 공간을 차지하게 */}
          <Box component="main" flexGrow={1}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/nftlist/:page?" element={<NFTList />} />
              <Route path="/test" element={<Test />} />
              <Route path="/login" element={<Login user={user} setUser={setUser} />} />
              <Route path="/register" element={<Register user={user} setUser={setUser} />} />
              <Route path="/profile" element={<Profile user={user} setUser={setUser}/>} />
              <Route path="/wallet" element={<Wallet user={user} setUser={setUser}/>} />
              <Route path="/NFTManage" element={<NFTManage user={user} setUser={setUser}/>} />
              <Route path="/nft1/:id" element={<NFTDetail user={user} setUser={setUser}/>} />
              <Route path="/nftcreate" element={<NFTCreate user={user} setUser={setUser}/>} />
              <Route path="/nft/:id" element={<NFTDetail user={user} setUser={setUser}/>} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/metamask-register" element={<MetaRegister />} />
              <Route path="/user/:userId" element={<UserProfile user={user} setUser={setUser}/>} />

            </Routes>
          </Box>

          {/* 🔧 Footer는 항상 맨 아래 */}
          <Footer />
        </Box>
      </Router>
    </ThemeProvider>
  );
};

export default App;
